import { permissions as userPermissions } from './permissions';
import { can } from './privileges';

export const permissions = { ...userPermissions, can };
